export const HS_CODE_LENGTH = 6
